import Api from "@/configurations/Api";
import RequestService from "@/configurations/AxiosConfig";
import { IExportPatrolReportToExcelRequest, IExportPatrolReportToPdfRequest, IExportPatrolsToExcelRequest, IExportPatrolsToPdfRequest, IPatrolCopyLastMonthPlanRequest, IPatrolEditRequest } from "@/types/type";
import { toast } from "sonner";

const endpoints = {
  patrols: 'patrols',
  completed: 'patrols/completed',
  patrolsByCompanyId: 'patrols/byCompanyId',
  completedPatrolsByCompanyId: 'patrols/completed/byCompanyId',
};

const PatrolsService = {
  getAllPatrols: async () => RequestService.get(endpoints.patrols),
  getPatrolsByCompanyId: async (companyId: string | number) => RequestService.get(`${endpoints.patrolsByCompanyId}/${companyId}`),
  getCompletedPatrolsByCompanyId: async (companyId: string | number) => RequestService.get(`${endpoints.completedPatrolsByCompanyId}/${companyId}`),
  getPatrolById: async (id: string | number) => RequestService.get(`${endpoints.patrols}/${id}`),
  updatePatrols: async (id: string | number, data: IPatrolEditRequest) => RequestService.patch(`${endpoints.patrols}/${id}`, data),
  createPatrol: (data: any) => RequestService.post(endpoints.patrols, data),
  deletePatrol: (id: string | number) => RequestService.patch(`${endpoints.patrols}/delete/${id}`),
  deletePatternInPatrol: (id: string | number) => RequestService.patch(`${endpoints.patrols}/delete/pattern/${id}`),
  completedRoutes: async () => RequestService.get(endpoints.completed),
  getPatrolsByUserId: async (userId: string | number) => RequestService.get(`${endpoints.patrols}/user/${userId}`),
  getPatrolsReport: async (data: any) => RequestService.post(`${endpoints.patrols}/report`, data),
  copyLastMonthPlanDto: async (data: IPatrolCopyLastMonthPlanRequest) => RequestService.post(`${endpoints.patrols}/copyLastMonthPlanDto`, data),
  exportPatrolsToExcel: async (data: IExportPatrolsToExcelRequest) => {
    const response = await fetch(`${Api.getBaseUrl()}patrols/exportPatrolsToExcel`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        'Authorization': `${RequestService.defaults.headers.common.Authorization}`,
      },
      body: JSON.stringify(data)
    });
    if (!response.ok) {
      toast.error("Dosya indirme işlemi başarısız oldu.")
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const blob = await response.blob()

    if (!blob.type.includes("spreadsheet") && !blob.type.includes("excel")) {
      console.warn("Response might not be an Excel file:", blob.type)
    }

    const downloadUrl = window.URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = downloadUrl
    link.download = 'patrols.xlsx'

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    window.URL.revokeObjectURL(downloadUrl)

    toast.success("Dosya başarıyla indirildi.")
  },
  exportPatrolReportToExcel: async (data: IExportPatrolReportToExcelRequest) => {
    const response = await fetch(`${Api.getBaseUrl()}patrols/exportPatrolReportToExcel`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        'Authorization': `${RequestService.defaults.headers.common.Authorization}`,
      },
      body: JSON.stringify(data)
    });
    if (!response.ok) {
      toast.error("Dosya indirme işlemi başarısız oldu.")
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const blob = await response.blob()

    if (!blob.type.includes("spreadsheet") && !blob.type.includes("excel")) {
      console.warn("Response might not be an Excel file:", blob.type)
    }

    const downloadUrl = window.URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = downloadUrl
    link.download = 'patrols.xlsx'

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    window.URL.revokeObjectURL(downloadUrl)

    toast.success("Dosya başarıyla indirildi.")
  },
  exportPatrolsToPdf: async (data: IExportPatrolsToPdfRequest) => {
    const response = await fetch(`${Api.getBaseUrl()}patrols/exportPatrolsToPdf`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        'Authorization': `${RequestService.defaults.headers.common.Authorization}`,
      },
      body: JSON.stringify(data)
    });
    if (!response.ok) {
      toast.error("Dosya indirme işlemi başarısız oldu.")
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const blob = await response.blob()

    if (!blob.type.includes("spreadsheet") && !blob.type.includes("pdf")) {
      console.warn("Response might not be a PDF file:", blob.type)
    }

    const downloadUrl = window.URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = downloadUrl
    link.download = 'patrols.pdf'

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    window.URL.revokeObjectURL(downloadUrl)

    toast.success("Dosya başarıyla indirildi.")
  },
  exportPatrolReportToPdf: async (data: IExportPatrolReportToPdfRequest) => {
    const response = await fetch(`${Api.getBaseUrl()}patrols/exportPatrolReportToPdf`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        'Authorization': `${RequestService.defaults.headers.common.Authorization}`,
      },
      body: JSON.stringify(data)
    });
    if (!response.ok) {
      toast.error("Dosya indirme işlemi başarısız oldu.")
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const blob = await response.blob()

    if (!blob.type.includes("spreadsheet") && !blob.type.includes("pdf")) {
      console.warn("Response might not be a PDF file:", blob.type)
    }

    const downloadUrl = window.URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = downloadUrl
    link.download = 'patrols.pdf'

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    window.URL.revokeObjectURL(downloadUrl)

    toast.success("Dosya başarıyla indirildi.")
  }
};

export default PatrolsService;
